﻿import {useEffect, useState} from 'react';
import type {Supplier} from "../../types/Supplier";
import {hasAdminAccess} from "../../util/AccountUtils";
import type {Account} from "../../types/Account";

interface SupplierFiltersParams {
    unfilteredLocations: Supplier[];
    instantApprovalOnly: boolean;
    user: Account | undefined | null;
    onlyLiveLocations: boolean;
    selectedFeatures: Array<string>;
    selectedEquipment: Array<string>;
}

export const useSupplierFilters = ({unfilteredLocations, instantApprovalOnly, user, onlyLiveLocations, selectedFeatures, selectedEquipment}: SupplierFiltersParams): {
    filteredLocations: Supplier[]
} => {
    const [filteredLocations, setFilteredLocations] = useState<Supplier[]>([]);

    useEffect(() => {
        setFilteredLocations(() => unfilteredLocations.filter((location: Supplier) => {
            if (!location.visible) {
                if (!hasAdminAccess(user) || onlyLiveLocations) return false;
            }
            let hasCapacity = true;
            if (!location.hasInstantApproval && instantApprovalOnly) hasCapacity = false;
            if (!hasCapacity) return false;

            let hasFeatures = true;
            if (selectedFeatures.length > 0) {
                hasFeatures = selectedFeatures.every((feature) => location.features.includes(feature));
            }
            if (!hasFeatures) return false;

            let hasEquipment = true;
            if (selectedEquipment.length > 0) {
                hasEquipment = location.equipmentTypes && selectedEquipment.every((equipment) => location.equipmentTypes.includes(equipment));
            }
            return hasEquipment;
        }));
    }, [unfilteredLocations, instantApprovalOnly, user, onlyLiveLocations, selectedFeatures, selectedEquipment]);

    return {filteredLocations}
}
